<template>
  <v-container>
    <PageHeader :title="pageTitle" :path="goToPath" />
    <!-- campos de busqueda -->
    <v-card>
      <v-container
        class="pt-2"
        :class="{ 'pb-0': !showFilters, 'pb-4': showFilters }"
      >
        <v-card-actions
          v-if="filtersApplied && filtersApplied.length > 0 && !showFilters"
        >
          <v-row :no-gutters="isMobile">
            <v-col v-if="!isMobile" cols="11">
              <filters-selected
                :filtersApplied="filtersApplied"
                @chip-click="handleChipClick"
              />
            </v-col>
            <v-col
              v-else
              cols="12"
              v-for="(filter, key) in filtersApplied"
              :key="key"
            >
              <v-chip
                class="mr-2"
                label
                outlined
                color="primary"
                @click="handleChipClick(filter)"
                :id="'v-chip-' + key"
              >
                {{
                  `${filter.label}: ${
                    Array.isArray(filter.model)
                      ? getTextWhenFilterIsArray(filter)
                      : filter.model
                  }`
                }}
              </v-chip>
            </v-col>
            <v-col :cols="isMobile ? 12 : 1" class="pl-12 pr-0">
              <v-tooltip location="left">
                <template v-slot:activator="{ props }">
                  <v-btn
                    :icon="showFilters ? 'mdi-chevron-up' : 'mdi-chevron-down'"
                    size="25px"
                    v-bind="props"
                    class="mr-5 white--text"
                    :class="isMobile ? 'to-right' : ''"
                    @click.stop="showFilters = !showFilters"
                    id="v-btn-showfilters"
                  >
                  </v-btn>
                </template>
                {{ !showFilters ? "Mostrar filtros" : "Ocultar filtros" }}
              </v-tooltip>
            </v-col>
          </v-row>
        </v-card-actions>
        <v-expand-transition mode="out-in">
          <v-form
            v-show="showFilters"
            v-model="isFormValid"
            ref="filters-form"
            id="filters-form"
            @submit.prevent="loadUsuarios()"
          >
            <v-row :no-gutters="isMobile">
              <v-col :cols="isMobile ? 12 : 3" v-if="isFilterVisible('emisor')">
                <v-autocomplete
                  label="Emisores"
                  v-model="selectedEmisor"
                  :items="emisor"
                  item-title="value1"
                  return-object
                  :readonly="emisor.length === 1"
                  :menu-props="{ contentClass: 'usuarios-autocomplete-menu' }"
                  :disabled="financiador.length === 1 || farmacia.length === 1"
                  :clearable="emisor.length !== 1"
                  density="compact"
                  variant="outlined"
                  id="v-select-emisor"
                  :custom-filter="safeLabelFilter"
                >
                  <template #item="{ item, props }">
                    <v-list-item v-bind="filterProps(props)" v-on="filterOn(props)">
                      <div class="usuarios-item-content">
                        <v-list-item-title class="usuarios-item-title">{{ getItemName(getUnderlying(item)) }}</v-list-item-title>
                        <v-list-item-subtitle v-if="getItemCuit(getUnderlying(item))" class="usuarios-item-subtitle">(CUIT: {{ getItemCuit(getUnderlying(item)) }})</v-list-item-subtitle>
                      </div>
                    </v-list-item>
                  </template>
                  <template #selection="{ item }">
                    <div
                      class="usuarios-selection"
                      :title="getSelectionTitle(getUnderlying(item)) + (getSelectionSubtitle(getUnderlying(item)) ? ' ' + getSelectionSubtitle(getUnderlying(item)) : '')"
                    >
                      <div class="usuarios-selection-title">{{ getSelectionTitle(getUnderlying(item)) }}</div>
                      <div v-if="getSelectionSubtitle(getUnderlying(item))" class="usuarios-selection-subtitle">{{ getSelectionSubtitle(getUnderlying(item)) }}</div>
                    </div>
                  </template>
                  <template v-if="false">
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col :cols="isMobile ? 12 : 3" v-if="isFilterVisible('financiador')">
                <v-autocomplete
                  label="Financiadores"
                  v-model="selectedFinanciador"
                  :items="financiador"
                  item-title="value1"
                  return-object
                  :readonly="financiador.length === 1"
                  :menu-props="{ contentClass: 'usuarios-autocomplete-menu' }"
                  :disabled="emisor.length === 1 || farmacia.length === 1"
                  :clearable="financiador.length !== 1"
                  density="compact"
                  variant="outlined"
                  id="v-select-financiador"
                  :custom-filter="safeLabelFilter"
                >
                  <template #item="{ item, props }">
                    <v-list-item v-bind="filterProps(props)" v-on="filterOn(props)">
                      <div class="usuarios-item-content">
                        <v-list-item-title class="usuarios-item-title">{{ getItemName(getUnderlying(item)) }}</v-list-item-title>
                        <v-list-item-subtitle v-if="getItemCuit(getUnderlying(item))" class="usuarios-item-subtitle">({{ getItemCuit(getUnderlying(item)) }})</v-list-item-subtitle>
                      </div>
                    </v-list-item>
                  </template>
                  <template #selection="{ item }">
                    <div class="usuarios-selection">
                      <div class="usuarios-selection-title">{{ getSelectionTitle(getUnderlying(item)) }}</div>
                      <div v-if="getSelectionSubtitle(getUnderlying(item))" class="usuarios-selection-subtitle">{{ getSelectionSubtitle(getUnderlying(item)) }}</div>
                    </div>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col :cols="isMobile ? 12 : 3" v-if="isFilterVisible('prestador')">
                <v-autocomplete
                  label="Médicos emisores"
                  v-model="selectedPrestador"
                  :items="prestador"
                  item-title="value1"
                  return-object
                  :readonly="prestador.length === 1"
                  :menu-props="{ contentClass: 'usuarios-autocomplete-menu' }"
                  :disabled="financiador.length === 1 || emisor.length === 1"
                  :clearable="prestador.length !== 1"
                  density="compact"
                  variant="outlined"
                  id="v-select-prestador"
                  :custom-filter="safeLabelFilter"
                >
                  <template #item="{ item, props }">
                    <v-list-item v-bind="filterProps(props)" v-on="filterOn(props)">
                      <div class="usuarios-item-content">
                        <v-list-item-title class="usuarios-item-title">{{ getItemName(getUnderlying(item)) }}</v-list-item-title>
                        <v-list-item-subtitle v-if="getItemCuit(getUnderlying(item))" class="usuarios-item-subtitle">(CUIT: {{ getItemCuit(getUnderlying(item)) }})</v-list-item-subtitle>
                      </div>
                    </v-list-item>
                  </template>
                  <template #selection="{ item }">
                    <div class="usuarios-selection">
                      <div class="usuarios-selection-title">{{ getSelectionTitle(getUnderlying(item)) }}</div>
                      <div v-if="getSelectionSubtitle(getUnderlying(item))" class="usuarios-selection-subtitle">{{ getSelectionSubtitle(getUnderlying(item)) }}</div>
                    </div>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col :cols="isMobile ? 12 : 3" v-if="isFilterVisible('farmacia')">
                <v-autocomplete
                  label="Farmacias"
                  v-model="selectedFarmacia"
                  :items="farmacia"
                  item-title="value1"
                  return-object
                  :readonly="farmacia.length === 1"
                  :menu-props="{ contentClass: 'usuarios-autocomplete-menu' }"
                  :disabled="financiador.length === 1 || emisor.length === 1"
                  :clearable="farmacia.length !== 1"
                  density="compact"
                  variant="outlined"
                  id="v-select-farmacia"
                  :custom-filter="safeLabelFilter"
                >
                  <template #item="{ item, props }">
                    <v-list-item v-bind="filterProps(props)" v-on="filterOn(props)">
                      <div class="usuarios-item-content">
                        <v-list-item-title class="usuarios-item-title">{{ getItemName(getUnderlying(item)) }}</v-list-item-title>
                        <v-list-item-subtitle v-if="getItemCuit(getUnderlying(item))" class="usuarios-item-subtitle">(CUIT: {{ getItemCuit(getUnderlying(item)) }})</v-list-item-subtitle>
                      </div>
                    </v-list-item>
                  </template>
                  <template #selection="{ item }">
                    <div class="usuarios-selection">
                      <div class="usuarios-selection-title">{{ getSelectionTitle(getUnderlying(item)) }}</div>
                      <div v-if="getSelectionSubtitle(getUnderlying(item))" class="usuarios-selection-subtitle">{{ getSelectionSubtitle(getUnderlying(item)) }}</div>
                    </div>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col :cols="isMobile ? 12 : 3" v-if="isFilterVisible('grupo')">
                <v-select
                  label="Grupos de usuarios"
                  v-model="selectedGrupo"
                  :items="grupo"
                  return-object
                  item-value="id"
                  item-title="value"
                  clearable
                  density="compact"
                  variant="outlined"
                  id="v-select-grupo"
                ></v-select>
              </v-col>
            </v-row>
            <v-row class="text-right" :no-gutters="isMobile">
              <v-col cols="12">
                <v-tooltip location="left">
                  <template v-slot:activator="{ props }">
                    <v-icon
                      @click="clearSelections"
                      color="grey"
                      v-bind="props"
                      class="mr-5 white--text"
                      size="25px"
                      id="v-icon-limpiarfiltros"
                      >{{ clearFilters }}</v-icon
                    >
                  </template>
                  Limpiar filtros</v-tooltip
                >
                <v-btn
                  color="primary"
                  type="submit"
                  form="filters-form"
                  id="v-btn-aplicar"
                >
                  APLICAR
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-expand-transition>
      </v-container>
    </v-card>
    <v-card class="elevation-1 mt-2">
      <v-card-text class="py-0 my-0">
        <v-row :no-gutters="isMobile">
          <v-col cols="12" class="mx-0 px-0">
            <v-data-table
              :headers="headers"
              :items="users"
              item-value="name"
              :mobile="isMobile"
              :hide-default-header="isMobile"
              class="pa-3"
              :loading="isLoading"
              :search="search"
            >
              <template v-slot:[`item.dobleFactorHabilitado`]="{ item }">
                <v-icon
                  small
                  :color="!item.dobleFactorHabilitado ? 'red' : 'green'"
                >
                  {{ !item.dobleFactorHabilitado ? crossIcon : checkIcon }}
                </v-icon>
              </template>
              <template v-slot:top>
                <v-container>
                  <!-- Layout unificado responsive -->
                  <v-row>
                    <v-col :cols="isMobile ? 12 : 6">
                      <v-text-field
                        v-model="search"
                        :append-icon="searchIcon"
                        label="Buscar"
                        single-line
                        hide-details
                        clearable
                        variant="underlined"
                        :id="isMobile ? 'v-text-field-search-mobile' : 'v-text-field-search'"
                      ></v-text-field>
                    </v-col>
                    <v-col 
                      :cols="isMobile ? 12 : 4" 
                      :class="isMobile ? 'text-center py-2' : 'text-center mt-2'"
                    >
                      <v-menu offset-y>
                        <template v-slot:activator="{ props }">
                          <v-btn
                            color="primary"
                            variant="outlined"
                            v-bind="props"
                            :id="isMobile ? 'v-btn-envio-masivo-mobile' : 'v-btn-envio-masivo'"
                            :prepend-icon="massCredentialsIcon"
                            :block="isMobile"
                            aria-label="Envío masivo de credenciales"
                          >
                            Envío masivo de credenciales
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item
                            @click="openDialogSeleccionarFinanciador"
                            v-if="isAdmin"
                          >
                            <v-list-item-title
                              >Envío por financiador</v-list-item-title
                            >
                          </v-list-item>
                          <v-list-item @click="openDialogEnvioPorUsuarios">
                            <v-list-item-title
                              >Envío por usuarios</v-list-item-title
                            >
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-col>
                    <v-col 
                      :cols="isMobile ? 12 : 2" 
                      :class="isMobile ? 'text-center py-2' : 'text-right mt-2'"
                      v-if="permisosUsuarios.canCreate"
                    >
                      <v-btn
                        @click="openNuevoUsuarioDialog"
                        color="primary"
                        variant="flat"
                        :id="isMobile ? 'v-btn-nuevo-mobile' : 'v-btn-nuevo'"
                        :block="isMobile"
                        aria-label="Crear nuevo usuario"
                        >Nuevo</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-container>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-tooltip location="left">
                  <template v-slot:activator="{ props }">
                    <v-icon
                      v-bind="props"
                      size="20"
                      @click="openModalRemoveQR(item)"
                      v-if="permisosUsuarios.canRemoveQR"
                      id="v-icon-remove-qr"
                      aria-label="Volver a generar código QR"
                    >
                      {{ qrCodeRemove }}
                    </v-icon>
                  </template>
                  <span>Volver a generar código QR</span>
                </v-tooltip>
                <v-tooltip location="left">
                  <template v-slot:activator="{ props }">
                    <v-icon
                      size="20"
                      @click="openModalGestionCredenciales(item)"
                      v-bind="props"
                      id="v-icon-gestionCredenciales"
                      aria-label="Gestionar credenciales"
                      >{{ credentialsIcon }}</v-icon
                    >
                  </template>
                  Credenciales
                </v-tooltip>

                <v-tooltip location="left">
                  <template v-slot:activator="{ props }">
                    <v-icon
                      size="20"
                      @click="openEditUsuario(item)"
                      v-bind="props"
                      v-if="permisosUsuarios.canEdit"
                      id="v-icon-editar"
                      aria-label="Editar usuario"
                      >{{ editIcon }}</v-icon
                    >
                  </template>
                  Editar usuario
                </v-tooltip>
                <v-tooltip location="left">
                  <template v-slot:activator="{ props }">
                    <v-icon
                      size="20"
                      @click="openDeleteAlert(item.userId)"
                      v-bind="props"
                      v-if="permisosUsuarios.canDelete"
                      id="v-icon-eliminar"
                      aria-label="Eliminar usuario"
                      >{{ deleteIcon }}</v-icon
                    >
                  </template>
                  Eliminar usuario
                </v-tooltip>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- dialog -->
    <v-dialog
      v-if="modalRemoveUserQR"
      v-model="modalRemoveUserQR"
      :max-width="isMobile ? '95%' : '30%'"
      @keydown.esc="closeDialog"
      persistent
    >
      <RemoveQr :userId="userId" @closeDialog="closeDialog()" />
    </v-dialog>
    <v-dialog
      v-if="isOpenEditUsuario"
      v-model="isOpenEditUsuario"
      :max-width="isMobile ? '95%' : '45%'"
      persistent
    >
      <EditUsuario
        :usuarioItemProp="usuarioItem"
        :emisores="emisor"
        :financiadores="financiador"
        :grupos="grupo"
        :farmacias="farmacia"
        @closeDialog="closeDialog($event)"
        @usuarioGuardado="loadUsuarios"
      />
    </v-dialog>
    <v-dialog
      v-if="isOpenModalGestionCredenciales"
      v-model="isOpenModalGestionCredenciales"
      :max-width="isMobile ? '95%' : '70%'"
      persistent
    >
      <GestionCredenciales
        :userId="selectedUsuario?.userId"
        :usuarioNombre="selectedUsuario?.userName"
        :usuarioCambioContraseñaLogin="
          selectedUsuario?.usuarioCambioContraseñaLogin
        "
        :usuarioUltimoInicioSesion="selectedUsuario?.usuarioUltimoInicioSesion"
        @closeDialog="closeDialog($event)"
      />
    </v-dialog>
    <v-dialog
      :max-width="isMobile ? '95%' : '30%'"
      v-model="dialogDelete"
      persistent
    >
      <DeleteDialog
        v-if="dialogDelete"
        title="usuario"
        :subtitle="deleteSubtitle"
        :isLoading="isLoadingDelete"
        @eliminar-confirmado="confirmDelete"
        @eliminar-cancelado="closeDeleteDialog"
      />
    </v-dialog>
    <v-dialog
      v-if="dialogEnvioPorUsuarios"
      v-model="dialogEnvioPorUsuarios"
      :max-width="isMobile ? '95%' : '65%'"
      persistent
    >
      <SeleccionarUsuarioEnvioCredenciales
        @closeDialog="closeDialogEnvioPorUsuarios"
      />
    </v-dialog>
    <v-dialog
      v-if="dialogSeleccionarFinanciador"
      v-model="dialogSeleccionarFinanciador"
      :max-width="isMobile ? '95%' : '65%'"
      persistent
    >
      <SeleccionarFinanciadorEnvioCredenciales
        @closeDialog="closeDialogSeleccionarFinanciador"
      />
    </v-dialog>
  </v-container>
</template>

<script>
import EditUsuario from "@/components/modules/usuarios/EditUsuario.vue";
import RemoveQr from "@/components/modules/usuarios/RemoveQr.vue";
import GestionCredenciales from "@/components/modules/usuarios/GestionCredenciales.vue";
import SeleccionarUsuarioEnvioCredenciales from "@/components/modules/usuarios/SeleccionarUsuarioEnvioCredenciales.vue";
import SeleccionarFinanciadorEnvioCredenciales from "@/components/modules/usuarios/SeleccionarFinanciadorEnvioCredenciales.vue";
import enums from "@/utils/enums/index";
import { mapActions, mapGetters } from "vuex";
import PageHeader from "@/components/layout/PageHeader.vue";
import DeleteDialog from "@/components/shared/DeleteDialog.vue";
import FiltersSelected from "@/components/shared/FiltersSelected.vue";

// Helpers puros hoisteados (sin uso de `this`) para reutilizar en el componente
function normalizeDigits(str) {
  return (str || '').replace(/[^0-9]/g, '');
}

function getUnderlying(item) {
  if (!item) return null;
  let u = item.raw ?? item.value ?? item.item ?? item;
  if (u && typeof u === 'object' && u.value && typeof u.value === 'object') {
    u = u.value;
  }
  return u;
}

function getItemName(item) {
  if (!item) return '';
  return item.value1 || item.value || item.nombre || item.razonSocial || '';
}

function getItemCuit(item) {
  if (!item) return '';
  return item.value2 || item.cuit || item.Cuit || '';
}

function buildPlainList(arr) {
  if (!Array.isArray(arr)) return [];
  const res = [];
  for (let i = 0; i < arr.length; i++) {
    const it = arr[i] || {};
    const id = it.id ?? it.Id ?? it.value ?? it.Value ?? it.preId ?? it.PreId ?? it.tpId ?? it.TpId ?? null;
    const rawName = it.value1 ?? it.Value1 ?? it.value ?? it.Value ?? it.nombre ?? it.Nombre ?? it.razonSocial ?? it.TpNombre ?? it.NombreCartilla ?? '';
    const rawCuit = it.value2 ?? it.Value2 ?? it.cuit ?? it.Cuit ?? it.pre_cuit ?? it.preCuit ?? it.PreCuit ?? it.codigo ?? it.Codigo ?? it.DocId ?? '';
    const value1 = (typeof rawName === 'string' || typeof rawName === 'number') ? String(rawName).trim() : '';
    const value2 = (typeof rawCuit === 'string' || typeof rawCuit === 'number') ? String(rawCuit).trim() : '';
    const suffix = value2 ? `(CUIT: ${value2})` : '';
    const label = `${value1}${suffix ? '\n' + suffix : ''}`;
    res.push({ id, value1, value2, label });
  }
  return res;
}

function safeLabelFilter(item, queryText, itemText) {
  try {
    if (!queryText) return true;
    const text = (typeof itemText === 'string' || typeof itemText === 'number')
      ? String(itemText)
      : JSON.stringify(itemText);
    const query = String(queryText).toLowerCase().trim();
    if (text.toLowerCase().includes(query)) return true;
    const queryDigits = normalizeDigits(query);
    if (queryDigits) {
      const underlying = getUnderlying(item);
      const itemCuit = getItemCuit(underlying);
      const itemCuitDigits = normalizeDigits(itemCuit);
      if (itemCuitDigits && itemCuitDigits.includes(queryDigits)) return true;
    }
    return false;
  } catch (e) {
    return false;
  }
}

function debounce(fn, wait) {
  let t = null;
  return function(...args) {
    if (t) clearTimeout(t);
    t = setTimeout(() => fn(...args), wait);
  };
}

export default {
  name: "UsuariosView",
  components: {
    EditUsuario,
    RemoveQr,
    GestionCredenciales,
    SeleccionarUsuarioEnvioCredenciales,
    SeleccionarFinanciadorEnvioCredenciales,
    PageHeader,
    DeleteDialog,
    FiltersSelected,
  },
  data() {
    return {
      headers: [
        {
          title: "Nombre",
          sortable: false,
          key: "userName",
        },
        {
          title: "Email",
          key: "email",
          sortable: false,
        },
        {
          title: "Grupo de permisos",
          key: "grupoUsuario.value",
          sortable: false,
        },
        {
          title: "Doble factor",
          key: "dobleFactorHabilitado",
          sortable: false,
          align: "center",
        },
        { title: "Acciones", key: "actions", align: "end", sortable: false },
      ],
      users: [],
      emisor: [],
      financiador: [],
      prestador: [],
      grupo: [],
      farmacia: [],
      filtersApplied: [],
      selectedEmisor: null,
      selectedFinanciador: null,
      selectedPrestador: null,
      selectedGrupo: null,
      selectedFarmacia: null,
      usuarioItem: null,
      userToDelete: null,
      search: "",
      searchIcon: enums.icons.SEARCH_ICON,
      checkIcon: enums.icons.CHECK_ICON,
      crossIcon: enums.icons.CROSS_ICON,
      editIcon: enums.icons.EDIT_ICON,
      deleteIcon: enums.icons.DELETE_ICON,
      clearFilters: enums.icons.CLEAR_FILTERS,
      pageTitle: enums.permises.USUARIOS.name,
      goToPath: enums.permises.HOME.path,
      isLoading: false,
      isOpenEditUsuario: false,
      dialogDelete: false,
      isLoadingDelete: false,
      showFilters: true,
      isFormValid: false,
      deleteSubtitle: enums.messages.USUARIOS_DELETE_SUBTITLE,
      userId: null,
      qrCodeRemove: enums.icons.QRCODE_REMOVE,
      modalRemoveUserQR: false,
      isOpenModalGestionCredenciales: false,
      selectedUsuario: null,
      credentialsIcon: enums.icons.CREDENTIALS_ICON,
      massCredentialsIcon: enums.icons.MASS_CREDENTIALS_ICON,
      dialogEnvioPorUsuarios: false,
      dialogSeleccionarFinanciador: false,
      userLoggedType: null,
    };
  },
  computed: {
    ...mapGetters({
      permisos: "menu/permisos",
      isMobile: "menu/isMobile",
    }),
    permisosUsuarios() {
      const flags = { canCreate: false, canEdit: false, canDelete: false, canRemoveQR: false };
      const codeToFlag = {
        [enums.permises.CREAR_USUARIO.code]: 'canCreate',
        [enums.permises.EDITAR_USUARIO.code]: 'canEdit',
        [enums.permises.ELIMINAR_USUARIO.code]: 'canDelete',
        [enums.permises.REMOVE_QR.code]: 'canRemoveQR',
      };
      (this.permisos || []).forEach((p) => {
        const key = codeToFlag[p.permisoCodigo];
        if (key) flags[key] = true;
      });
      return flags;
    },
    
    isAdmin() {
      return this.userLoggedType?.esAdmin;
    },
    // Control centralizado de visibilidad de filtros por rol
    // Para agregar nuevos roles o filtros, actualizar el mapa FILTROS_POR_ROL
    currentUserRole() {
      if (!this.userLoggedType) return null;
      
      if (this.userLoggedType.esAdmin) return 'admin';
      if (this.userLoggedType.financiadorId) return 'financiador';
      if (this.userLoggedType.emisorId) return 'emisor';
      if (this.userLoggedType.farmaciaId) return 'farmacia';
      
      return null; // rol no identificado
    },
    FILTROS_POR_ROL() {
      return {
        admin: ['emisor', 'financiador', 'farmacia', 'prestador', 'grupo'],
        financiador: ['grupo']
      };
    },
    isFilterVisible() {
      return (filterKey) => {
        // Si userLoggedType no está cargado, ocultar todos los filtros
        if (!this.userLoggedType) return false;
        
        // Si el rol no está en el mapa, ocultar todos los filtros
        const role = this.currentUserRole;
        if (!role || !this.FILTROS_POR_ROL[role]) return false;
        
        // Si el filtro no está en la lista para ese rol, ocultarlo
        return this.FILTROS_POR_ROL[role].includes(filterKey);
      };
    },
  },
  watch: {
    search() {
      if (this.debouncedLoadUsuarios) {
        this.debouncedLoadUsuarios();
      } else {
        this.loadUsuarios();
      }
    },
  },
  async created() {
    await this.loadCombos();
    await this.getUserLoggedType();
    this.loadUsuarios();
    // inicializar debounce para búsqueda
    this.debouncedLoadUsuarios = debounce(() => this.loadUsuarios(), 400);
    this.$store.dispatch("user/changeAppLoading", {
      status: false,
      text: "",
    });
  },

  methods: {
    ...mapActions({
      getUsuarios: "user/getUsuarios",
      getEmisores: "taxonomy/getEmisoresCUITByUser",
      getFinanciadores: "taxonomy/getFinanciadoresByUser",
      getGruposUsuarios: "taxonomy/getGruposUsuariosByUser",
      getFarmacias: "taxonomy/getFarmaciasCUITByUser",
      getPrestadores: "taxonomy/fetchPrestadoresByQuery",
      getPrestadoresAll: "taxonomy/getPrestadoresAll",
      deleteUsuario: "user/deleteUsuario",
      setAlert: "user/setAlert",
      getFiltersByUser: "solicitud/getFiltersByUser",
    }),
    // Utilidades para manejo de nombre y CUIT en selects (referencia a helpers hoisteados)
    getItemName,
    getItemCuit,
    normalizeDigits,
    getUnderlying,
    async getUserLoggedType() {
      const userLogged = await this.getFiltersByUser();
      this.userLoggedType = userLogged;
    },
    async loadCombos() {
      try {
        const [emisorResp, financiadorResp, grupoResp, farmaciaResp] = await Promise.all([
          this.getEmisores(),
          this.getFinanciadores(),
          this.getGruposUsuarios(),
          this.getFarmacias(),
        ]);

        this.emisor = buildPlainList(emisorResp);
        if (this.emisor.length === 1) this.selectedEmisor = this.emisor[0];

        this.financiador = buildPlainList(financiadorResp).map(i => ({ ...i, tipo: 'financiador' }));
        if (this.financiador.length === 1) this.selectedFinanciador = this.financiador[0];

        this.grupo = Array.isArray(grupoResp) ? grupoResp : (grupoResp || []);

        // Cargar prestadores (si el endpoint devuelve una lista grande podríamos convertir esto a búsqueda asíncrona)
        try {
          const prestResp = await this.getPrestadoresAll();
          this.prestador = buildPlainList(prestResp || []);
          if (this.prestador.length === 1) this.selectedPrestador = this.prestador[0];
        } catch (e) {
          this.prestador = [];
        }

        this.farmacia = buildPlainList(farmaciaResp);
        if (this.farmacia.length === 1) this.selectedFarmacia = this.farmacia[0];
      } catch (err) {
        this.setAlert({ type: "error", message: "Error al cargar combos" });
        this.emisor = [];
        this.financiador = [];
        this.grupo = [];
        this.farmacia = [];
      }
    },
    safeLabelFilter,

    

    // Compat helpers for v-list-item props/on (evitan pasar objetos que Vuetify no acepte)
    filterProps(props) {
      // props puede contener campos que Vuetify interpreta como VNode props (ej. title/value)
      // que en nuestro caso contienen objetos (item completos). Normalizamos para evitar
      // pasar objetos donde se espera string/number.
      if (!props || typeof props !== 'object') return {};
      const out = { ...props };
      // Evitar renderizado por defecto del title en v-list-item (provoca duplicado de líneas)
      // Eliminamos siempre title para que solo nuestro template personalizado muestre el contenido
      if (out.title) delete out.title;
      if (out.value && typeof out.value !== 'string' && typeof out.value !== 'number') {
        delete out.value;
      }
      // eliminar listeners no serializables si vienen mal formateados; handlers se pasan via filterOn
      if (out.on) delete out.on;
      return out;
    },

    filterOn(props) {
      if (!props || typeof props.on !== 'object') return {};
      return props.on;
    },

    // Helpers para selection slot - manejan tanto objetos como strings/primitivos
    getSelectionTitle(item) {
      if (!item) return '';
      const u = item;
      if (typeof u === 'object') {
        if (u.value1) return u.value1;
        if (u.label) return u.label;
        // intentar propiedades comunes
        if (u.name) return u.name;
        if (u.title) return u.title;
        // como último recurso serializar el objeto para evitar [object Object]
        try {
          return JSON.stringify(u);
        } catch (e) {
          return String(u);
        }
      }
      return String(u);
    },

    getSelectionSubtitle(item) {
      if (!item) return '';
      const u = item;
      if (typeof u === 'object') {
        if (u.tipo === 'financiador' && u.value2) return `(${u.value2})`;
        if (u.tipo === 'financiador' && u.cuit) return `(CUIT: ${u.cuit})`;
        if (u.value2) return `(CUIT: ${u.value2})`;
        if (u.cuit) return `(CUIT: ${u.cuit})`;
        return '';
      }
      return '';
    },

    async loadUsuarios() {
      this.isLoading = true;
      this.customizeFiltersApplied();
      const payload = {
        emisorId: this.selectedEmisor?.id,
        financiadorId: this.selectedFinanciador?.id,
        preId: this.getUnderlying(this.selectedPrestador)?.id ?? this.selectedPrestador?.id,
        grupoUsuId: this.selectedGrupo?.id,
        farmaciaId: this.selectedFarmacia?.id,

      };
      try {
        const response = await this.getUsuarios(payload);
        this.users = response;
      } catch (error) {
        this.setAlert({ type: 'error', message: 'Error al cargar usuarios' });
        this.users = [];
      } finally {
        this.isLoading = false;
        this.showFilters = false;
      }
    },
    handleChipClick() {
      this.showFilters = true;
    },
    customizeFiltersApplied() {
      this.filtersApplied = [];
      
      const addFilter = (key, label, model) => {
        if (model) {
          this.filtersApplied.push({ key, label, model });
        }
      };
      
      addFilter("emisorNom", "Emisor", this.getItemName(this.selectedEmisor));
      addFilter(
        "financiadorNom",
        "Financiador",
        this.selectedFinanciador?.value1
      );
      addFilter("prestadorNom", "Médico emisor", this.getItemName(this.selectedPrestador));
      addFilter("FarmaciaNom", "Farmacia", this.getItemName(this.selectedFarmacia));
      addFilter("GrupoNom", "Grupo", this.selectedGrupo?.value);
      
      // Agregar "Todos" solo si no hay filtros aplicados
      if (this.filtersApplied.length === 0) {
        this.filtersApplied.push({ key: "todos", label: "Filtros", model: "Todos" });
      }

      this.showFilters = true;
    },
    openEditUsuario(item) {
      this.isOpenEditUsuario = true;
      this.usuarioItem = item;
    },
    closeDialog(reload) {
      this.isOpenEditUsuario = false;
      this.isOpenModalGestionCredenciales = false;
      this.modalRemoveUserQR = false;
      this.dialogEnvioPorUsuarios = false;
      this.dialogSeleccionarFinanciador = false;
      this.usuarioItem = null;
      this.selectedUsuario = null;
      if (reload) {
        this.loadUsuarios();
      }
    },
    clearSelections() {
      this.selectedEmisor = null;
      this.selectedFinanciador = null;
      this.selectedGrupo = null;
      this.selectedFarmacia = null;
      this.filtersApplied = [];
    },
    openNuevoUsuarioDialog() {
      this.isOpenEditUsuario = true;
    },
    openDeleteAlert(id) {
      this.dialogDelete = true;
      this.userToDelete = id;
    },
    closeDeleteDialog() {
      this.dialogDelete = false;
    },
    async confirmDelete() {
      this.isLoadingDelete = true;
      try {
        const response = await this.deleteUsuario(this.userToDelete);
        if (response?.status == 200) {
          this.setAlert({ type: "success", message: "Eliminado con éxito." });
          this.dialogDelete = false;
          this.loadUsuarios();
        }
      } catch (error) {
        console.error(error)
      }
      this.isLoadingDelete = false;
    },
    openModalRemoveQR(item) {
      this.modalRemoveUserQR = true;
      this.userId = item.userId;
    },
    openModalGestionCredenciales(item) {
      this.isOpenModalGestionCredenciales = true;
      this.selectedUsuario = item;
    },
    openDialogSeleccionarFinanciador() {
      this.dialogSeleccionarFinanciador = true;
    },
    closeDialogSeleccionarFinanciador() {
      this.dialogSeleccionarFinanciador = false;
    },
    openDialogEnvioPorUsuarios() {
      this.dialogEnvioPorUsuarios = true;
    },
    closeDialogEnvioPorUsuarios() {
      this.dialogEnvioPorUsuarios = false;
    },
    getTextWhenFilterIsArray(filter) {
      if (filter.model.length === 0) {
        return "Ninguno";
      }
      return filter.model.map((item) => item.value).join(", ");
    },
    
  },
};
</script>
<style scoped>
/* Dropdown: títulos y subtítulos dentro del menú del autocomplete */
.usuarios-autocomplete-menu .v-list-item__title {
  font-size: 0.9rem !important;
  white-space: pre-line;
}
.usuarios-item-title span {
  display: block;
}
.usuarios-item-content {
  display: flex;
  flex-direction: column;
}
.usuarios-item-title {
  font-weight: 500;
}
.usuarios-item-subtitle {
  font-size: 0.75rem !important;
  color: rgba(0,0,0,0.6);
}
.usuarios-autocomplete-menu .usuarios-item-content {
  display: flex;
  flex-direction: column;
}
.usuarios-autocomplete-menu .usuarios-item-title {
  font-weight: 500;
  color: rgba(0,0,0,0.87);
}
.usuarios-autocomplete-menu .usuarios-item-subtitle {
  font-size: 0.85em;
  color: rgba(0,0,0,0.6);
}

/* Forzar layout de dos líneas en dropdown */
.usuarios-autocomplete-menu .v-list-item {
  align-items: flex-start !important;
  white-space: normal !important;
  min-height: 48px !important;
}
.usuarios-autocomplete-menu .usuarios-item-content {
  display: block !important;
  width: 100%;
}
.usuarios-autocomplete-menu .usuarios-item-subtitle {
  display: block;
  margin-top: 2px;
}

/* Estilos para campo seleccionado */
/* Selección (valor mostrado en el input del autocomplete) */
.usuarios-selection {
  display: flex;
  flex-direction: column;
  width: 100%;
  white-space: normal;
}
.usuarios-selection-title {
  /* Título mostrado en el input seleccionado (compacto) */
  font-weight: 500;
  line-height: 1.2;
  font-size: 0.9rem !important;
}
.usuarios-selection-subtitle {
  /* Subtítulo mostrado en el input seleccionado (aún más pequeño) */
  font-size: 0.75rem !important;
  color: rgba(0,0,0,0.6);
  line-height: 1.1;
  margin-top: 1px;
}

/* Forzar que el input del autocomplete permita contenido multilínea */
.v-field--variant-outlined .usuarios-selection,
.v-field--variant-filled .usuarios-selection,
.v-field--variant-underlined .usuarios-selection {
  white-space: normal !important;
}
.v-field__input .usuarios-selection {
  white-space: normal !important;
}

/* Truncamiento: mostrar una sola línea con ellipsis en la selección del autocomplete */
.usuarios-selection {
  min-width: 0; /* permite que los hijos se encojan en flex containers */
}

.v-field--variant-outlined .usuarios-selection .usuarios-selection-title,
.v-field--variant-filled .usuarios-selection .usuarios-selection-title,
.v-field--variant-underlined .usuarios-selection .usuarios-selection-title,
.v-field__input .usuarios-selection .usuarios-selection-title {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  display: block;
  max-width: 100%;
}

.v-field--variant-outlined .usuarios-selection .usuarios-selection-subtitle,
.v-field--variant-filled .usuarios-selection .usuarios-selection-subtitle,
.v-field--variant-underlined .usuarios-selection .usuarios-selection-subtitle,
.v-field__input .usuarios-selection .usuarios-selection-subtitle {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  display: block;
  max-width: 100%;
  font-size: 0.85em;
}
</style>
